import { render } from "./login-form.vue?vue&type=template&id=6f4c06f9&ts=true"
import script from "./login-form.component.ts?vue&type=script&lang=ts&external"
export * from "./login-form.component.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__